// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8f6fd3c9","455":"a40381db","977":"84623fa4"}[chunkId] + ".chunk.js";
};